import React, { useState, useEffect } from 'react';
import { frontendMenuService } from '../../../services/frontendMenuService';
import { ppidContentService } from '../../../services/ppidContentService';
import PPIDContentForm from '../components/PPIDContentForm';
import { getAssetUrl } from '../../../services/api';
import { useAuth } from '../../Admin/context/AuthContext';   // ✅ sesuaikan path
import {
    FaPlus, FaEdit, FaTrash, FaSearch, FaList, FaTimes, FaSave,
    FaCheckCircle, FaExclamationTriangle, FaChevronDown, FaChevronRight,
    FaFolder, FaFile, FaEye, FaEyeSlash, FaExternalLinkAlt, FaHome,
    FaUser, FaServicestack, FaBuilding, FaChartPie, FaNewspaper,
    FaExclamationCircle, FaQuestionCircle, FaPhoneAlt, FaFlag, FaTasks,
    FaSitemap, FaFileAlt, FaHandshake, FaMoneyBillWave, FaCalculator,
    FaClipboardList, FaBook, FaBullhorn, FaGavel, FaLink, FaBalanceScale,
    FaCity, FaLandmark, FaWhatsapp, FaMailBulk, FaKey, FaBan, FaFolderOpen,
    FaMinus, FaImage,
    FaFilePdf, FaPaperclip, FaDownload
} from 'react-icons/fa';

// Icon mapping
const iconMap = {
    'FaHome': FaHome,
    'FaUser': FaUser,
    'FaServicestack': FaServicestack,
    'FaBuilding': FaBuilding,
    'FaChartPie': FaChartPie,
    'FaNewspaper': FaNewspaper,
    'FaExclamationCircle': FaExclamationCircle,
    'FaQuestionCircle': FaQuestionCircle,
    'FaPhoneAlt': FaPhoneAlt,
    'FaFlag': FaFlag,
    'FaTasks': FaTasks,
    'FaSitemap': FaSitemap,
    'FaFileAlt': FaFileAlt,
    'FaHandshake': FaHandshake,
    'FaMoneyBillWave': FaMoneyBillWave,
    'FaCalculator': FaCalculator,
    'FaClipboardList': FaClipboardList,
    'FaBook': FaBook,
    'FaBullhorn': FaBullhorn,
    'FaGavel': FaGavel,
    'FaLink': FaLink,
    'FaBalanceScale': FaBalanceScale,
    'FaCity': FaCity,
    'FaLandmark': FaLandmark,
    'FaWhatsapp': FaWhatsapp,
    'FaMailBulk': FaMailBulk,
    'FaKey': FaKey,
    'FaBan': FaBan,
    'FaFolderOpen': FaFolderOpen
};

const iconOptions = Object.keys(iconMap);

const componentOptions = [
    'HomePage', 'VisiMisi', 'Tupoksi', 'StrukturOrganisasi', 'StandarPelayanan',
    'MaklumatPelayanan', 'LaporanIKM', 'RetribusiIPT', 'RetribusiIPR',
    'PerizinanIPT', 'HBGHPL', 'SewaBMD', 'SewaGedung', 'PanggungCreativa',
    'SuketMandiri', 'SuratPerizinan', 'APBDPage', 'InformasiPage', 'PPIDPage',
    'ProdukHukumPage', 'ArtikelPage', 'KontakPage', 'AduanPage', 'FAQPage',
    'BidangPage', 'SurveyPage', 'AgendaPage'
];

const typeOptions = [
    { value: 'internal', label: 'Internal Route' },
    { value: 'external', label: 'External Link' },
    { value: 'group', label: 'Group (Submenu)' },
    { value: 'heading', label: 'Heading (Label)' },
];

const ManajemenFrontendMenu = () => {
    const [menus, setMenus] = useState([]);
    const [flatMenus, setFlatMenus] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedItems, setExpandedItems] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingMenu, setEditingMenu] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [notification, setNotification] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState(null);

    const [showContentForm, setShowContentForm] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState(null);

    // ✅ Ambil user dari AuthContext
    const { user } = useAuth();

    // ✅ Helper cek permission
    const hasPermission = (permission) => {
        if (!user) return false;
        if (user?.roles?.includes('admin')) return true;
        if (!user?.permissions) return false;
        return user.permissions.includes(permission);
    };

    const [formData, setFormData] = useState({
        name: '',
        slug: '',
        route: '',
        icon: 'FaFileAlt',
        parent_id: '',
        order: 0,
        type: 'internal',
        component: '',
        external_url: '',
        description: '',
        steps: [''],
        requirements: [''],
        contact_info: '',
        notice: '',
        is_active: true,
        is_visible: true,
        requires_auth: false,
        // Multiple image
        images: [],
        existing_images: [],
        remove_images: [],
        // Multiple file PDF
        files: [],
        existing_files: [],
        remove_files: [],
    });

    const [errors, setErrors] = useState({});

    const loadMenus = async () => {
        setLoading(true);
        const result = await frontendMenuService.getMenus({ search: searchTerm });
        if (result.success) {
            setMenus(result.data || []);
            setFlatMenus(flattenMenus(result.data || []));
        } else {
            showNotification(result.message, 'error');
        }
        setLoading(false);
    };

    useEffect(() => {
        loadMenus();
    }, []);

    const flattenMenus = (menuTree, level = 0) => {
        let result = [];
        menuTree.forEach(menu => {
            result.push({ ...menu, level, displayName: `${'—'.repeat(level)} ${menu.name}` });
            if (menu.children && menu.children.length > 0) {
                result = result.concat(flattenMenus(menu.children, level + 1));
            }
        });
        return result;
    };

    const showNotification = (message, type = 'success') => {
        setNotification({ message, type });
        setTimeout(() => setNotification(null), 3000);
    };

    const toggleExpand = (menuId) => {
        setExpandedItems(prev =>
            prev.includes(menuId) ? prev.filter(id => id !== menuId) : [...prev, menuId]
        );
    };

    const handleCreate = (parentId = '') => {
        setEditingMenu(null);
        setFormData({
            name: '', slug: '', route: '', icon: 'FaFileAlt', parent_id: parentId,
            order: 0, type: 'internal', component: '', external_url: '',
            is_active: true, is_visible: true, requires_auth: false,
            description: '',
            steps: [''],
            requirements: [''],
            contact_info: '',
            notice: '',
            images: [],
            existing_images: [],
            remove_images: [],
            files: [],
            existing_files: [],
            remove_files: [],
        });
        setErrors({});
        setShowForm(true);
    };

    const handleEdit = (menu) => {
        setEditingMenu(menu);

        // ✅ Normalisasi existing_files menjadi array
        let existingFiles = [];
        const rawFiles = menu.file_paths || menu.files || (menu.file_path ? [menu.file_path] : []);

        if (Array.isArray(rawFiles)) {
            existingFiles = rawFiles;
        } else if (typeof rawFiles === 'string') {
            // Kalau string JSON, parse dulu
            try {
                const parsed = JSON.parse(rawFiles);
                existingFiles = Array.isArray(parsed) ? parsed : [rawFiles];
            } catch {
                // Kalau bukan JSON, anggap single path
                existingFiles = rawFiles ? [rawFiles] : [];
            }
        } else if (rawFiles && typeof rawFiles === 'object') {
            // Kalau object, mungkin {path: '...'} → jadikan array
            existingFiles = [rawFiles.path || rawFiles.url || ''].filter(Boolean);
        }

        // ✅ Normalisasi existing_images juga (untuk aman)
        let existingImages = [];
        const rawImages = menu.image_paths || menu.images || (menu.image_path ? [menu.image_path] : []);
        if (Array.isArray(rawImages)) {
            existingImages = rawImages;
        } else if (typeof rawImages === 'string') {
            try {
                const parsed = JSON.parse(rawImages);
                existingImages = Array.isArray(parsed) ? parsed : [rawImages];
            } catch {
                existingImages = rawImages ? [rawImages] : [];
            }
        } else if (rawImages && typeof rawImages === 'object') {
            existingImages = [rawImages.path || rawImages.url || ''].filter(Boolean);
        }

        setFormData({
            name: menu.name || '',
            slug: menu.slug || '',
            route: menu.route || '',
            icon: menu.icon || 'FaFileAlt',
            parent_id: menu.parent_id || '',
            order: menu.order || 0,
            type: menu.type || 'internal',
            component: menu.component || '',
            external_url: menu.external_url || '',
            description: menu.description || '',
            steps: Array.isArray(menu.steps) && menu.steps.length > 0 ? menu.steps : [''],
            requirements: Array.isArray(menu.requirements) && menu.requirements.length > 0 ? menu.requirements : [''],
            contact_info: menu.contact_info || '',
            notice: menu.notice || '',
            is_active: menu.is_active === true || menu.is_active === 1,
            is_visible: menu.is_visible === true || menu.is_visible === 1,
            requires_auth: menu.requires_auth === true || menu.requires_auth === 1,
            images: [],
            existing_images: existingImages,
            remove_images: [],
            files: [],
            existing_files: existingFiles,
            remove_files: [],
        });
        setErrors({});
        setShowForm(true);
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleArrayChange = (field, index, value) => {
        const newArray = [...formData[field]];
        newArray[index] = value;
        setFormData(prev => ({ ...prev, [field]: newArray }));
    };

    const addArrayItem = (field) => {
        setFormData(prev => ({ ...prev, [field]: [...(prev[field] || []), ''] }));
    };

    const removeArrayItem = (field, index) => {
        const currentArray = formData[field] || [];
        if (currentArray.length <= 1) return;
        const newArray = currentArray.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, [field]: newArray }));
    };

    // Handler multiple image
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;

        const validFiles = [];
        const maxSize = 2 * 1024 * 1024;
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

        files.forEach(file => {
            if (!allowedTypes.includes(file.type)) {
                showNotification(`File ${file.name} bukan gambar yang valid (JPG/PNG/WEBP)`, 'error');
                return;
            }
            if (file.size > maxSize) {
                showNotification(`File ${file.name} melebihi 2MB`, 'error');
                return;
            }
            validFiles.push(file);
        });

        if (validFiles.length > 0) {
            setFormData(prev => ({
                ...prev,
                images: [...prev.images, ...validFiles]
            }));
        }
        e.target.value = '';
    };

    const removeNewImage = (index) => {
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }));
    };

    const removeExistingImage = (imagePath) => {
        setFormData(prev => ({
            ...prev,
            existing_images: prev.existing_images.filter(img => img !== imagePath),
            remove_images: [...prev.remove_images, imagePath]
        }));
    };

    const undoRemoveExistingImage = (imagePath) => {
        setFormData(prev => ({
            ...prev,
            existing_images: [...prev.existing_images, imagePath],
            remove_images: prev.remove_images.filter(img => img !== imagePath)
        }));
    };

    // Handler multiple file PDF
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;

        const validFiles = [];
        const maxSize = 10 * 1024 * 1024;
        const allowedTypes = ['application/pdf'];

        files.forEach(file => {
            if (!allowedTypes.includes(file.type)) {
                showNotification(`File ${file.name} bukan PDF`, 'error');
                return;
            }
            if (file.size > maxSize) {
                showNotification(`File ${file.name} melebihi 10MB`, 'error');
                return;
            }
            validFiles.push(file);
        });

        if (validFiles.length > 0) {
            setFormData(prev => ({
                ...prev,
                files: [...prev.files, ...validFiles]
            }));
        }
        e.target.value = '';
    };

    const removeNewFile = (index) => {
        setFormData(prev => ({
            ...prev,
            files: prev.files.filter((_, i) => i !== index)
        }));
    };

    const removeExistingFile = (filePath) => {
        setFormData(prev => ({
            ...prev,
            existing_files: prev.existing_files.filter(f => f !== filePath),
            remove_files: [...prev.remove_files, filePath]
        }));
    };

    const undoRemoveExistingFile = (filePath) => {
        setFormData(prev => ({
            ...prev,
            existing_files: [...prev.existing_files, filePath],
            remove_files: prev.remove_files.filter(f => f !== filePath)
        }));
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    };

    const getFileNameFromPath = (path) => {
        if (!path) return 'file.pdf';
        return path.split('/').pop();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const fd = new FormData();
        fd.append('name', formData.name || '');
        fd.append('slug', formData.slug || '');
        fd.append('route', formData.route || '');
        fd.append('icon', formData.icon || '');
        fd.append('parent_id', formData.parent_id || '');
        fd.append('order', parseInt(formData.order) || 0);
        fd.append('type', formData.type || 'internal');
        fd.append('component', formData.component || '');
        fd.append('external_url', formData.external_url || '');
        fd.append('description', formData.description || '');
        fd.append('contact_info', formData.contact_info || '');
        fd.append('notice', formData.notice || '');
        fd.append('is_active', formData.is_active ? 1 : 0);
        fd.append('is_visible', formData.is_visible ? 1 : 0);
        fd.append('requires_auth', formData.requires_auth ? 1 : 0);

        (formData.steps || []).forEach((step, i) => {
            if (step && step.trim()) fd.append(`steps[${i}]`, step);
        });
        (formData.requirements || []).forEach((req, i) => {
            if (req && req.trim()) fd.append(`requirements[${i}]`, req);
        });

        formData.images.forEach((file) => {
            fd.append('images[]', file);
        });

        formData.remove_images.forEach((path, i) => {
            fd.append(`remove_images[${i}]`, path);
        });

        formData.files.forEach((file) => {
            fd.append('files[]', file);
        });

        formData.remove_files.forEach((path, i) => {
            fd.append(`remove_files[${i}]`, path);
        });

        let result;
        if (editingMenu) {
            result = await frontendMenuService.updateMenu(editingMenu.id, fd);
        } else {
            result = await frontendMenuService.createMenu(fd);
        }

        if (result.success) {
            showNotification(result.message || 'Menu berhasil disimpan', 'success');
            setShowForm(false);
            loadMenus();
        } else {
            showNotification(result.message || 'Gagal menyimpan', 'error');
        }
        setSubmitting(false);
    };

    const handleDelete = (menu) => setDeleteConfirm(menu);

    const confirmDelete = async () => {
        if (!deleteConfirm) return;
        const result = await frontendMenuService.deleteMenu(deleteConfirm.id);
        if (result.success) {
            showNotification('Menu berhasil dihapus', 'success');
            loadMenus();
        } else {
            showNotification(result.message, 'error');
        }
        setDeleteConfirm(null);
    };

    const handleToggleActive = async (menu) => {
        const result = await frontendMenuService.toggleActive(menu.id);
        if (result.success) {
            showNotification(result.message, 'success');
            loadMenus();
        } else {
            showNotification(result.message, 'error');
        }
    };

    const getIconComponent = (iconName) => iconMap[iconName] || FaFileAlt;

    // ✅ Render menu tree dengan permission check
    const renderMenuTree = (menuList, level = 0) => {
        return menuList.map((menu) => {
            const hasChildren = menu.children && menu.children.length > 0;
            const isExpanded = expandedItems.includes(menu.id);
            const Icon = getIconComponent(menu.icon);

            const isPPIDMenu = menu.slug === 'ppid' ||
                menu.name.toLowerCase().includes('ppid') ||
                menu.route?.includes('/informasi/ppid') ||
                menu.slug?.startsWith('ppid-');

            return (
                <div key={menu.id}>
                    <div className={`flex items-center justify-between p-3 rounded-lg mb-2 transition-all ${level === 0 ? 'bg-gradient-to-r from-[#0F4C3A] to-[#2E7D32] text-white' : 'bg-white border border-gray-200'
                        }`} style={{ marginLeft: level * 20 }}>
                        <div className="flex items-center flex-1">
                            {hasChildren && (
                                <button onClick={() => toggleExpand(menu.id)} className="mr-2 p-1 rounded">
                                    {isExpanded ? <FaChevronDown size={14} /> : <FaChevronRight size={14} />}
                                </button>
                            )}
                            <Icon className={`mr-3 ${level === 0 ? 'text-white' : 'text-gray-500'}`} />
                            <div>
                                <p className={`font-medium ${level === 0 ? 'text-white' : 'text-gray-700'}`}>{menu.name}</p>
                                <p className={`text-xs ${level === 0 ? 'text-white/70' : 'text-gray-500'}`}>
                                    {menu.route || menu.external_url || menu.slug}
                                </p>
                            </div>
                            <div className="ml-4 flex items-center space-x-2">
                                <span className={`text-xs px-2 py-0.5 rounded-full ${menu.type === 'group' ? 'bg-purple-100 text-purple-600' : menu.type === 'external' ? 'bg-orange-100 text-orange-600' : 'bg-blue-100 text-blue-600'}`}>
                                    {menu.type}
                                </span>
                                {menu.is_active ? (
                                    <span className="bg-green-100 text-green-700 text-xs px-2 py-0.5 rounded-full">Aktif</span>
                                ) : (
                                    <span className="bg-gray-100 text-gray-500 text-xs px-2 py-0.5 rounded-full">Nonaktif</span>
                                )}
                            </div>
                        </div>

                        {/* ✅ Actions — dengan permission check */}
                        <div className="flex items-center space-x-1 ml-4">
                            {/* Kelola Konten PPID */}
                            {isPPIDMenu && hasPermission('ppid.update') && (
                                <button
                                    onClick={() => {
                                        setSelectedMenu(menu);
                                        setShowContentForm(true);
                                    }}
                                    className={`p-2 rounded-lg transition-colors ${level === 0
                                        ? 'text-white/80 hover:bg-white/20'
                                        : 'text-orange-500 hover:bg-orange-50'
                                        }`}
                                    title={`Kelola Konten ${menu.name}`}
                                >
                                    <FaFolderOpen size={14} />
                                </button>
                            )}

                            {/* Tambah Submenu */}
                            {hasChildren && hasPermission('frontend-menus.create') && (
                                <button onClick={() => handleCreate(menu.id)} className="p-2 rounded-lg hover:bg-white/20" title="Tambah Submenu">
                                    <FaPlus size={14} />
                                </button>
                            )}

                            {/* Edit */}
                            {hasPermission('frontend-menus.update') && (
                                <button onClick={() => handleEdit(menu)} className="p-2 rounded-lg hover:bg-white/20" title="Edit">
                                    <FaEdit size={14} />
                                </button>
                            )}

                            {/* Toggle Aktif */}
                            {hasPermission('frontend-menus.update') && (
                                <button onClick={() => handleToggleActive(menu)} className="p-2 rounded-lg hover:bg-white/20" title="Toggle Aktif">
                                    {menu.is_active ? <FaEye size={14} /> : <FaEyeSlash size={14} />}
                                </button>
                            )}

                            {/* Hapus */}
                            {hasPermission('frontend-menus.delete') && (
                                <button onClick={() => handleDelete(menu)} className="p-2 rounded-lg hover:bg-white/20" title="Hapus">
                                    <FaTrash size={14} />
                                </button>
                            )}
                        </div>
                    </div>
                    {hasChildren && isExpanded && renderMenuTree(menu.children, level + 1)}
                </div>
            );
        });
    };

    return (
        <div>
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
                <div>
                    <h2 className="text-2xl font-bold text-[#0F4C3A]">Manajemen Menu Frontend</h2>
                    <p className="text-gray-600">Kelola menu navigasi website</p>
                </div>
                {/* ✅ Tombol Tambah Menu — cek permission */}
                {hasPermission('frontend-menus.create') && (
                    <button onClick={() => handleCreate()} className="btn-primary flex items-center justify-center">
                        <FaPlus className="mr-2" /> Tambah Menu
                    </button>
                )}
            </div>

            {notification && (
                <div className={`mb-6 p-4 rounded-lg flex items-center ${notification.type === 'success' ? 'bg-green-50 border border-green-200 text-green-700' : 'bg-red-50 border border-red-200 text-red-700'
                    }`}>
                    {notification.type === 'success' ? <FaCheckCircle className="mr-3" /> : <FaExclamationTriangle className="mr-3" />}
                    {notification.message}
                </div>
            )}

            <div className="bg-white rounded-xl p-4 shadow-sm mb-6">
                <div className="relative">
                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Cari menu..." className="w-full pl-10 pr-4 py-2.5 border rounded-lg" />
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-4">
                {loading ? (
                    <div className="text-center py-12">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2E7D32] mx-auto"></div>
                    </div>
                ) : menus.length === 0 ? (
                    <div className="text-center py-12 text-gray-500">Tidak ada data menu</div>
                ) : (
                    renderMenuTree(menus)
                )}
            </div>

            {/* Form Modal */}
            {showForm && (
                <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-bold text-[#0F4C3A]">
                                    {editingMenu ? 'Edit Menu' : 'Tambah Menu'}
                                </h3>
                                <button onClick={() => setShowForm(false)} className="text-gray-400 hover:text-gray-600">
                                    <FaTimes size={20} />
                                </button>
                            </div>
                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Nama Menu *</label>
                                        <input type="text" name="name" value={formData.name} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg" required />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Slug</label>
                                        <input type="text" name="slug" value={formData.slug} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg" placeholder="auto-generated" />
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Route</label>
                                        <input type="text" name="route" value={formData.route} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg" placeholder="/profil/visi-misi" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Icon</label>
                                        <select name="icon" value={formData.icon} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg">
                                            {iconOptions.map(icon => <option key={icon} value={icon}>{icon}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
                                        <select name="type" value={formData.type} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg">
                                            {typeOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Parent Menu</label>
                                        <select name="parent_id" value={formData.parent_id} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg">
                                            <option value="">Tidak ada (Root)</option>
                                            {flatMenus.filter(m => m.id !== editingMenu?.id).map(menu => (
                                                <option key={menu.id} value={menu.id}>{menu.displayName}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {formData.type === 'internal' && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Component</label>
                                        <select name="component" value={formData.component} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg">
                                            <option value="">Pilih Component</option>
                                            {componentOptions.map(comp => <option key={comp} value={comp}>{comp}</option>)}
                                        </select>
                                    </div>
                                )}

                                {formData.type === 'external' && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">External URL</label>
                                        <input type="url" name="external_url" value={formData.external_url} onChange={handleInputChange}
                                            className="w-full px-4 py-2.5 border rounded-lg" placeholder="https://..." />
                                    </div>
                                )}

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Order</label>
                                    <input type="number" name="order" value={formData.order} onChange={handleInputChange}
                                        className="w-full px-4 py-2.5 border rounded-lg" min="0" />
                                </div>

                                {formData.type === 'external' && (
                                    <>
                                        {/* Deskripsi */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Deskripsi Layanan
                                            </label>
                                            <textarea
                                                name="description"
                                                value={formData.description}
                                                onChange={handleInputChange}
                                                rows="3"
                                                className="w-full px-4 py-2.5 border rounded-lg"
                                                placeholder="Deskripsi singkat tentang layanan ini..."
                                            />
                                        </div>

                                        {/* Prosedur */}
                                        <div>
                                            <div className="flex justify-between items-center mb-2">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Prosedur Layanan
                                                </label>
                                                <button
                                                    type="button"
                                                    onClick={() => addArrayItem('steps')}
                                                    className="text-sm text-[#2E7D32] hover:text-[#4CAF50] flex items-center gap-1"
                                                >
                                                    <FaPlus size={12} /> Tambah
                                                </button>
                                            </div>
                                            {formData.steps.map((step, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                    <span className="w-8 h-11 flex items-center justify-center bg-[#0F4C3A] text-white rounded-lg font-bold text-sm flex-shrink-0">
                                                        {index + 1}
                                                    </span>
                                                    <input
                                                        type="text"
                                                        value={step}
                                                        onChange={(e) => handleArrayChange('steps', index, e.target.value)}
                                                        className="flex-1 px-4 py-2 border rounded-lg"
                                                        placeholder={`Langkah ke-${index + 1}`}
                                                    />
                                                    {formData.steps.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeArrayItem('steps', index)}
                                                            className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                                                        >
                                                            <FaMinus />
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Persyaratan */}
                                        <div>
                                            <div className="flex justify-between items-center mb-2">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Persyaratan
                                                </label>
                                                <button
                                                    type="button"
                                                    onClick={() => addArrayItem('requirements')}
                                                    className="text-sm text-[#2E7D32] hover:text-[#4CAF50] flex items-center gap-1"
                                                >
                                                    <FaPlus size={12} /> Tambah
                                                </button>
                                            </div>
                                            {formData.requirements.map((req, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        value={req}
                                                        onChange={(e) => handleArrayChange('requirements', index, e.target.value)}
                                                        className="flex-1 px-4 py-2 border rounded-lg"
                                                        placeholder={`Persyaratan ke-${index + 1}`}
                                                    />
                                                    {formData.requirements.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeArrayItem('requirements', index)}
                                                            className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                                                        >
                                                            <FaMinus />
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Contact Info */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Info Kontak
                                            </label>
                                            <input
                                                type="text"
                                                name="contact_info"
                                                value={formData.contact_info}
                                                onChange={handleInputChange}
                                                className="w-full px-4 py-2.5 border rounded-lg"
                                                placeholder="Contoh: Hubungi (0293) 123456 untuk info lebih lanjut"
                                            />
                                        </div>

                                        {/* Notice */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Catatan Tambahan
                                            </label>
                                            <textarea
                                                name="notice"
                                                value={formData.notice}
                                                onChange={handleInputChange}
                                                rows="2"
                                                className="w-full px-4 py-2.5 border rounded-lg"
                                                placeholder="Catatan penting untuk pengguna..."
                                            />
                                        </div>

                                        {/* Multiple Image Upload */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Gambar Layanan (Multiple)
                                            </label>

                                            <label
                                                htmlFor="images-upload"
                                                className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-[#2E7D32] hover:bg-green-50/30 transition-colors"
                                            >
                                                <FaImage className="text-2xl text-gray-400 mb-2" />
                                                <p className="text-sm text-gray-500">Klik untuk pilih gambar</p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    Format: JPG, PNG, WEBP • Maks 2MB per file
                                                </p>
                                                <input
                                                    id="images-upload"
                                                    type="file"
                                                    accept="image/jpeg,image/jpg,image/png,image/webp"
                                                    multiple
                                                    onChange={handleImageChange}
                                                    className="hidden"
                                                />
                                            </label>

                                            {formData.existing_images.length > 0 && (
                                                <div className="mt-4">
                                                    <p className="text-xs font-semibold text-gray-500 mb-2">
                                                        Gambar Tersimpan ({formData.existing_images.length})
                                                    </p>
                                                    <div className="grid grid-cols-3 gap-3">
                                                        {formData.existing_images.map((img, idx) => (
                                                            <div
                                                                key={`existing-${idx}`}
                                                                className="relative group border rounded-lg overflow-hidden"
                                                            >
                                                                <img
                                                                    src={img.startsWith('http') ? img : getAssetUrl(img)}
                                                                    alt={`existing-${idx}`}
                                                                    className="w-full h-24 object-cover"
                                                                    onError={(e) => {
                                                                        e.target.src = 'https://via.placeholder.com/150?text=No+Image';
                                                                    }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => removeExistingImage(img)}
                                                                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                                                                    title="Hapus gambar"
                                                                >
                                                                    <FaTimes size={10} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {formData.images.length > 0 && (
                                                <div className="mt-4">
                                                    <p className="text-xs font-semibold text-gray-500 mb-2">
                                                        Gambar Baru ({formData.images.length})
                                                    </p>
                                                    <div className="grid grid-cols-3 gap-3">
                                                        {formData.images.map((file, idx) => (
                                                            <div
                                                                key={`new-${idx}`}
                                                                className="relative group border rounded-lg overflow-hidden"
                                                            >
                                                                <img
                                                                    src={URL.createObjectURL(file)}
                                                                    alt={`new-${idx}`}
                                                                    className="w-full h-24 object-cover"
                                                                />
                                                                <div className="absolute top-1 left-1 bg-green-500 text-white text-[10px] px-1.5 py-0.5 rounded">
                                                                    Baru
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => removeNewImage(idx)}
                                                                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                                                                    title="Batal pilih"
                                                                >
                                                                    <FaTimes size={10} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {formData.remove_images.length > 0 && (
                                                <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                                                    <p className="text-xs text-red-700 mb-2">
                                                        {formData.remove_images.length} gambar akan dihapus saat disimpan.
                                                    </p>
                                                    <div className="flex flex-wrap gap-2">
                                                        {formData.remove_images.map((img, idx) => (
                                                            <button
                                                                key={`remove-${idx}`}
                                                                type="button"
                                                                onClick={() => undoRemoveExistingImage(img)}
                                                                className="text-xs text-red-600 hover:text-red-800 underline"
                                                            >
                                                                Batalkan hapus
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Multiple File PDF Upload */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Dokumen PDF Layanan (Multiple)
                                            </label>

                                            <label
                                                htmlFor="files-upload"
                                                className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-red-500 hover:bg-red-50/30 transition-colors"
                                            >
                                                <FaFilePdf className="text-2xl text-red-400 mb-2" />
                                                <p className="text-sm text-gray-500">Klik untuk pilih file PDF</p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    Format: PDF • Maks 10MB per file
                                                </p>
                                                <input
                                                    id="files-upload"
                                                    type="file"
                                                    accept="application/pdf"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    className="hidden"
                                                />
                                            </label>

                                            {formData.existing_files.length > 0 && (
                                                <div className="mt-4">
                                                    <p className="text-xs font-semibold text-gray-500 mb-2">
                                                        Dokumen Tersimpan ({formData.existing_files.length})
                                                    </p>
                                                    <div className="space-y-2">
                                                        {formData.existing_files.map((filePath, idx) => (
                                                            <div
                                                                key={`existing-file-${idx}`}
                                                                className="flex items-center justify-between p-3 bg-gray-50 border rounded-lg group"
                                                            >
                                                                <div className="flex items-center gap-3 min-w-0">
                                                                    <FaFilePdf className="text-red-500 flex-shrink-0" size={20} />
                                                                    <div className="min-w-0">
                                                                        <p className="text-sm text-gray-700 truncate">
                                                                            {getFileNameFromPath(filePath)}
                                                                        </p>
                                                                        <a
                                                                            href={filePath.startsWith('http') ? filePath : getAssetUrl(filePath)}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-xs text-[#2E7D32] hover:underline flex items-center gap-1"
                                                                        >
                                                                            <FaDownload size={10} /> Lihat
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => removeExistingFile(filePath)}
                                                                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors flex-shrink-0"
                                                                    title="Hapus file"
                                                                >
                                                                    <FaTimes size={14} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {formData.files.length > 0 && (
                                                <div className="mt-4">
                                                    <p className="text-xs font-semibold text-gray-500 mb-2">
                                                        Dokumen Baru ({formData.files.length})
                                                    </p>
                                                    <div className="space-y-2">
                                                        {formData.files.map((file, idx) => (
                                                            <div
                                                                key={`new-file-${idx}`}
                                                                className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg"
                                                            >
                                                                <div className="flex items-center gap-3 min-w-0">
                                                                    <FaFilePdf className="text-red-500 flex-shrink-0" size={20} />
                                                                    <div className="min-w-0">
                                                                        <p className="text-sm text-gray-700 truncate">
                                                                            {file.name}
                                                                        </p>
                                                                        <p className="text-xs text-gray-500">
                                                                            {formatFileSize(file.size)}
                                                                        </p>
                                                                    </div>
                                                                    <span className="bg-green-500 text-white text-[10px] px-1.5 py-0.5 rounded flex-shrink-0">
                                                                        Baru
                                                                    </span>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => removeNewFile(idx)}
                                                                    className="p-2 text-red-500 hover:bg-red-100 rounded-lg transition-colors flex-shrink-0"
                                                                    title="Batal pilih"
                                                                >
                                                                    <FaTimes size={14} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {formData.remove_files.length > 0 && (
                                                <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                                                    <p className="text-xs text-red-700 mb-2">
                                                        {formData.remove_files.length} dokumen akan dihapus saat disimpan.
                                                    </p>
                                                    <div className="flex flex-wrap gap-2">
                                                        {formData.remove_files.map((filePath, idx) => (
                                                            <button
                                                                key={`remove-file-${idx}`}
                                                                type="button"
                                                                onClick={() => undoRemoveExistingFile(filePath)}
                                                                className="text-xs text-red-600 hover:text-red-800 underline"
                                                            >
                                                                Batalkan hapus {getFileNameFromPath(filePath)}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}

                                <div className="grid grid-cols-3 gap-4">
                                    <label className="flex items-center">
                                        <input type="checkbox" name="is_active" checked={formData.is_active} onChange={handleInputChange}
                                            className="mr-2 text-[#2E7D32]" /> Aktif
                                    </label>
                                    <label className="flex items-center">
                                        <input type="checkbox" name="is_visible" checked={formData.is_visible} onChange={handleInputChange}
                                            className="mr-2 text-[#2E7D32]" /> Visible
                                    </label>
                                    <label className="flex items-center">
                                        <input type="checkbox" name="requires_auth" checked={formData.requires_auth} onChange={handleInputChange}
                                            className="mr-2 text-[#2E7D32]" /> Butuh Auth
                                    </label>
                                </div>

                                <div className="flex justify-end space-x-3 pt-4 border-t">
                                    <button type="button" onClick={() => setShowForm(false)} className="px-6 py-2.5 border rounded-lg">Batal</button>
                                    <button type="submit" disabled={submitting}
                                        className="flex items-center bg-gradient-to-r from-[#0F4C3A] to-[#2E7D32] text-white px-6 py-2.5 rounded-lg">
                                        {submitting ? 'Menyimpan...' : <><FaSave className="mr-2" /> Simpan</>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Modal */}
            {deleteConfirm && (
                <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl max-w-md w-full p-6 text-center">
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <FaTrash className="text-3xl text-red-500" />
                        </div>
                        <h3 className="text-xl font-bold mb-2">Hapus Menu?</h3>
                        <p className="text-gray-600 mb-6">Anda akan menghapus "{deleteConfirm.name}"</p>
                        <div className="flex justify-center gap-3">
                            <button onClick={() => setDeleteConfirm(null)} className="px-6 py-2.5 border rounded-lg">Batal</button>
                            <button onClick={confirmDelete} className="px-6 py-2.5 bg-red-500 text-white rounded-lg">Hapus</button>
                        </div>
                    </div>
                </div>
            )}
            {showContentForm && selectedMenu && (
                <PPIDContentForm
                    menu={selectedMenu}
                    onClose={() => { setShowContentForm(false); setSelectedMenu(null); }}
                />
            )}
        </div>
    );
};

export default ManajemenFrontendMenu;